module.exports = __webpack_public_path__ + "img/avatar-1.bf37e594.jpg";